module.exports = __webpack_public_path__ + "img/bricklayer.440af51b.png";